import { Grid, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import LinearProgress from "@mui/material/LinearProgress";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import TableChartIcon from "@mui/icons-material/TableChart";
import { observer } from "mobx-react";
import React, { useContext } from "react";
import { StoreContext } from "../StoreContext";
import { ProcessState } from "../stores/models";
import { useTranslation } from "react-i18next";
import FileUploadIcon from "@mui/icons-material/FileUpload";
const ActionWidget = observer((props) => {
    const context = useContext(StoreContext);
    const [t, i18n] = useTranslation();
    const onShowReport = (event) => {
        window.location.href = "/reports/process-controlling-cockpit";
    };
    const isUpdateButtonEnabled = () => {
        return context.rootStore.reportStore.reportState != ProcessState.LOADING;
    };
    const renderProgress = () => {
        if (context.rootStore.reportStore.reportState == ProcessState.LOADING ||
            context.rootStore.jobPanelStore.uploadState == ProcessState.LOADING ||
            context.rootStore.jobPanelStore.deleteState == ProcessState.LOADING) {
            return React.createElement(LinearProgress, null);
        }
        else {
            return React.createElement("div", null);
        }
    };
    const onUpdateReport = (event) => {
        context.rootStore.reportStore.updateReport();
    };
    const getLastASRefresh = () => {
        let panels = context.rootStore.jobPanelStore.jobPanels.filter((panel) => panel.reportUpdateTimeReadable);
        if (panels.length == 0) {
            return t("translations:label no update");
        }
        return panels[0].reportUpdateTimeReadable;
    };
    const onFileChange = (event) => {
        if (event.target && event.target.files && event.target.files[0]) {
            let files = event.target.files;
            for (let i = 0; i < files.length; ++i) {
                context.rootStore.jobPanelStore.addJobPanelEntry(files[i]);
            }
        }
    };
    return (React.createElement(Grid, { container: true },
        React.createElement(Grid, { container: true, item: true, xs: 12, spacing: 2, alignItems: "center" },
            React.createElement(Grid, { item: true },
                React.createElement("input", { style: { display: "none" }, id: "upload-file", multiple: true, type: "file", onChange: onFileChange }),
                React.createElement("label", { htmlFor: "upload-file" },
                    React.createElement(IconButton, { "aria-label": "upload data", onClick: () => { }, component: "span" },
                        React.createElement(FileUploadIcon, { fontSize: "large" }))),
                React.createElement(IconButton, { "aria-label": "update report", onClick: onUpdateReport, disabled: !isUpdateButtonEnabled() },
                    React.createElement(SaveAltIcon, { fontSize: "large" })),
                React.createElement(IconButton, { "aria-label": "show report", onClick: onShowReport },
                    React.createElement(TableChartIcon, { fontSize: "large" }))),
            React.createElement(Grid, { container: true, item: true, direction: "column", xs: 6 },
                React.createElement(Grid, { item: true },
                    React.createElement(Typography, { style: { fontWeight: 1000 } }, t("translations:label last refresh"))),
                React.createElement(Grid, { item: true },
                    React.createElement(Typography, null, getLastASRefresh())))),
        React.createElement(Grid, { item: true, xs: 12 }, renderProgress())));
});
export default ActionWidget;
